
import { Options, Vue } from 'vue-class-component';
import PlayLottieFile from '@/components/PlayLottieFile.vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src

@Options({
  components: {
    HelloWorld,
    PlayLottieFile,
  },
})
export default class Home extends Vue {}
